var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 20.8l-7.3-7.3L50 42.7 20.8 13.5l-7.3 7.3L42.7 50 13.5 79.2l7.3 7.3L50 57.3l29.2 29.2 7.3-7.3L57.3 50z",
    stroke: "null"
  })));
};
export default SvgClose;